<section class="what-makes">
    <div class="what-makes__layout">
        <div class="what-makes__text">
            <h2 class="what-makes__title">
                The Standards <br> We Refuse to Compromise <br> On Flavours
            </h2>
            <p class="what-makes__description" [innerHTML]="description">
            </p>
        </div>

        <div class="what-makes__items">
            <div class="what-makes__item">
                <p class="what-makes__item-title">
                    What's Inside Matters
                </p>
                <div class="what-makes__card what-makes__card--inside">
                    <ul class="what-makes__list">
                        <li class="what-makes__list-item" *ngFor="let point of insidePoints">
                            <img src="assets/images/checkmark-circle.svg" alt="" width="24" height="24" />
                            <div [innerHTML]="point.label"></div>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="what-makes__item">
                <p class="what-makes__item-title">
                    Strictly Off the Menu
                </p>
                <div class="what-makes__card what-makes__card--off">
                    <ul class="what-makes__list">
                        <li class="what-makes__list-item" *ngFor="let point of offMenuPoints">
                            <img src="assets/images/xmark.svg" alt="" width="24" height="24" />
                            <div [innerHTML]="point.label"></div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>
